import React, { useState, useEffect } from 'react';
import ReferenceCopy from '../reference-copy';

import './index.css';

const Journals = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/publications/preprints.json`;

    const [content, setContent] = useState([]);

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div id="Preprints" className="journals">
            <h3>Preprints</h3>
            <ol>
                {content.map((item, index) => {
                    return (
                        <li key={index}>
                            <p>
                                <a className="journal-title" target="blank" href={item.link}>
                                    {item.title}
                                </a>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <ReferenceCopy data={item} type="preprint" />
                            </p>
                            <span className="journal-author">
                                <i className="fas fa-user-friends" />
                                &nbsp;
                                {item.authors.map((author, authorIndex, arr) => {
                                    if (authorIndex === 0) return author;
                                    if (authorIndex === arr.length - 1) return ` & ${author}`;
                                    return `, ${author}`;
                                })}
                            </span>
                            <br />
                            <span className="journal-name">
                                <i className="fas fa-newspaper" />
                                &nbsp;&nbsp;&nbsp;
                                {item.preprint}
                            </span>
                            &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                            {item.year && item.year > 0 ? (
                                <span className="journal-year">{item.year}</span>
                            ) : (
                                ''
                            )}
                            &nbsp;
                            <span className="journal-status">
                                {item.status.length > 0 ? `(${item.status})` : ''}
                            </span>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default Journals;
